/**
 * What each way of refusing a campaign is called in the catalogue.
 *
 * `checkCampaign` returns **names and numbers, never sentences** — that is what
 * lets the same verdict be reached in the browser, on a server and inside an
 * Edge Function without any of them owning a language. This is the one table
 * that turns a name into wording, and it lives in `domain/` so that the
 * server-rendered panel and the static frontend cannot come to disagree about
 * what `list-undecided` means.
 *
 * Every one is a refusal. Warnings are not `CampaignProblem`s: §59 says the
 * administrator sees the truth and decides, so a two-segment message is
 * something to say and not something to block.
 */

import type { CampaignProblemName } from './campaign-check.ts';

/**
 * A plain string rather than the server's `MessageKey`, for the same reason
 * `smspro/status.ts` uses one: this module is imported by the browser bundle
 * and by Deno, and `i18n.ts` reads files. A test asserts every key here is
 * declared and translated, which is the guarantee the type would have given.
 */
export const CAMPAIGN_PROBLEM_MESSAGES: Readonly<Record<CampaignProblemName, string>> = {
  'list-over-limit': 'campaign.review.overLimit',
  'list-empty': 'campaign.review.empty',
  'list-undecided': 'campaign.review.undecided',
  'template-empty': 'campaign.template.empty',
  'template-no-placeholder': 'campaign.template.noPlaceholder',
  'template-too-long': 'campaign.template.tooLong',
};

export const CAMPAIGN_PROBLEM_NAMES = Object.keys(
  CAMPAIGN_PROBLEM_MESSAGES,
) as readonly CampaignProblemName[];
